// ignore-string-externalization

import { white, gray20 } from '@spotify-internal/encore-web';

export { gold } from '@spotify-internal/encore-web';
export { kleinBlue } from '@spotify-internal/encore-web';

export const goldHighlight = '#fbb250';
export const goldActive = '#d58010';

export const gridGutterWidth = '30px';

export const containerSm = `${720 + parseInt(gridGutterWidth, 10)}px`;
export const containerMd = `${940 + parseInt(gridGutterWidth, 10)}px`;
export const containerLg = `${1140 + parseInt(gridGutterWidth, 10)}px`;

export const zIndexNavbar = 1000;

export const navbarXsHeight = '54px';
export const navbarHeight = '80px';
export const navbarDefaultLinkColor = white;

export const fontFamilyBase = 'spotify-circular, @font-family-sans-serif';
export const fontWeightBook = 400;
export const fontWeightBold = 700;
export const fontWeightBlack = 900;

export const fontSizeH3 = '20px';
export const fontWeightH3 = fontWeightBlack;
export const lineHeightH3 = 1.4;
export const fontSizeH3Sm = '24px';
export const letterSpacingH3Sm = '-0.01em';

export const textColor = gray20;

export const btnLineHeight = 1;
export const btnFontSizeLg = '16px';
export const btnPaddingLargeVertical = '20px';
export const btnPaddingLargeHorizontal = `${Math.floor(
  parseInt(btnFontSizeLg, 10) * btnLineHeight +
    parseInt(btnPaddingLargeVertical, 10) * 2,
)}px`;
